/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FolderWrapper_viewer = {
    readonly folderItemMatches?: ReadonlyArray<{
        readonly item: {
            readonly serviceId: string | null;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"Folder_folderPortfolioItems">;
    } | null> | null;
    readonly __typename: "Viewer";
    readonly " $refType": "FolderWrapper_viewer";
};
export type FolderWrapper_viewer$data = FolderWrapper_viewer;
export type FolderWrapper_viewer$key = {
    readonly " $data"?: FolderWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"FolderWrapper_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "FolderWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "selectedItemIds",
      "type": "[String]",
      "defaultValue": []
    },
    {
      "kind": "LocalArgument",
      "name": "shouldFillInFolder",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String]",
      "defaultValue": []
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "__typename",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "shouldFillInFolder",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "folderItemMatches",
          "name": "portfolioItemMatches",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "itemIds",
              "variableName": "selectedItemIds"
            },
            {
              "kind": "Literal",
              "name": "portfolioTypes",
              "value": [
                "FOLDER"
              ]
            },
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userIds"
            }
          ],
          "concreteType": "PortfolioItemV2",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "item",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "serviceId",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "Folder_folderPortfolioItems",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '4501c5db1444387d57d54585de9323cb';
export default node;
